import React from 'react'
import { styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import theme from 'theme';

const PREFIX = 'LibraryBreadCrum';

const classes = {
  root: `${PREFIX}-root`,
  bread: `${PREFIX}-bread`
};

const Root = styled('div')((
  {
    theme: Theme
  }
) => ({
  [`&.${classes.root}`]: {
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },

  [`& .${classes.bread}`]: {
    cursor: 'pointer',
  }
}));

const LibraryBreadCrum = (props: any) => {


  const { breadCrumArray } = props

  return (
    <Root className={classes.root}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadCrumArray?.map((bread: any, i: number) => {
          return (
            <Typography
              color="textPrimary"
              onClick={props.handleBreadCrumClick.bind(null, bread)}
              key={i}
              className={classes.bread}
            >
              {bread.folderName}
            </Typography>
          )
        })}
      </Breadcrumbs>
    </Root>
  );
}

LibraryBreadCrum.defaultProps = {
  breadCrumArray: [{ name: 'Root', id: '1' }],
}
LibraryBreadCrum.propTypes = {
  breadCrumArray: PropTypes.array,
  handleBreadCrumClick: PropTypes.func,
}

export default LibraryBreadCrum
